import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { AutoTranslateDirective } from 'app/shared/directives/auto-translate.directive';
import { AutoTranslatePipe } from 'app/shared/pipes/translate.pipe';
export type DialogVisualType = 'error' | 'warning';

export interface DialogData {
    title: string;
    message: string;
    type?: DialogVisualType;
}
@Component({
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.scss'],
    standalone: true,
    imports: [MatIconModule, CommonModule, AutoTranslateDirective, AutoTranslatePipe],
})
export class ErrorDialogComponent {
    readonly dialogRef = inject(MatDialogRef<ErrorDialogComponent>);
    readonly data = inject<DialogData>(MAT_DIALOG_DATA);

    constructor() {
        this.dialogRef.addPanelClass('notification-dialog');
    }

    get isWarning(): boolean {
        if (this.data?.type) {
            return this.data.type === 'warning';
        }

        // Mantém compatibilidade com os pontos antigos que ainda abrem o
        // diálogo sem informar o tipo, mas usam "Atenção" no título.
        return this.data?.title?.trim().toLocaleLowerCase('pt-BR').startsWith('atenção') ?? false;
    }

    get heading(): string {
        return this.isWarning ? 'ATENÇÃO!' : 'ERRO!';
    }

    close(): void {
        this.dialogRef.close(false);
    }
    salvar(): void {
        this.dialogRef.close(false);
    }
}
